import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const connectedIntegrations = createSlice({
	name: 'connectedIntegrations',
	initialState,
	reducers: {
		setConnectedIntegrations: (state, { payload }) => [...payload],
		updateConnectedIntegration: (state, { payload }) => {
			const index = state.findIndex((item) => item.smsConfigID === payload.smsConfigID);
			state[index].status = payload.status;
			state[index].configName = payload.configName;
		}
	}
});
export const { setConnectedIntegrations, updateConnectedIntegration } = connectedIntegrations.actions;
export default connectedIntegrations.reducer;
